import React, { Component } from 'react';
import './ToastNotification.scss';

class ToastNotification extends Component {

  render() {
    const { shown, children, left } = this.props;

    let toastLeftClass = "toast left";
    let toastRightClass = "toast right";
    if (shown && left) toastLeftClass += " shown";
    else if (shown && !left) toastRightClass += " shown";

    return (
      <div onClick={this.props.onClick}>
        <div className={toastLeftClass}>
          {children}
        </div>
        <div className={toastRightClass} style={this.props.style}>
          {children}
        </div>
      </div>
    );
  }
}

export { ToastNotification };


// WEBPACK FOOTER //
// ./src/components/ToastNotification.js